<template>
    <v-container id="user" fluid>
      <v-row>
        <v-col cols="12">	
          <v-alert :value="userUpdateAlert.show" dense outlined :type="userUpdateAlert.type" :icon="userUpdateAlert.icon">{{ userUpdateAlert.message }}</v-alert>
        </v-col>
      </v-row>
			<v-row justify="center">
      	<v-col cols="12">				
				<v-card>
          <v-card-title>
            <span class="headline">Edit Profile</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="editUserForm">
              <v-container class="py-0">
                <v-row>
                  <v-col cols="12">
                    <v-text-field id="email" label="Email" name="email" type="text" v-model="getUser.email" autocomplete="off" :rules="[...getRlDialogRules.required, ...getRlDialogRules.email, ...getRlDialogRules.stringMax100]" counter="100" maxlength="100" :error-messages="userUpdateAlert.errors.email" />
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field id="name" label="Name" name="name" type="text" v-model="getUser.name" autocomplete="off" :rules="[...getRlDialogRules.stringMax100, ...getRlDialogRules.required]" counter="100" maxlength="100" :error-messages="userUpdateAlert.errors.name" />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field id="jobTitle" label="Job Title" name="name" type="text" v-model="getUser.job_title" autocomplete="off" :rules="[...getRlDialogRules.stringMax20, ...getRlDialogRules.required]" counter="20" maxlength="20" :error-messages="userUpdateAlert.errors.job_title" />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field id="telephoneNumber" label="Telephone Number" name="telephoneNumber" type="phone" v-model="getUser.tel" autocomplete="off" :rules="[...getRlDialogRules.stringMax20, ...getRlDialogRules.required]" counter="20" maxlength="20" :error-messages="userUpdateAlert.errors.tel" />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field id="companyName" label="Company Name" name="companyName" type="text" v-model="getUser.company_name" autocomplete="off" :rules="[...getRlDialogRules.stringMax50, ...getRlDialogRules.required]" counter="50" maxlength="50" :error-messages="userUpdateAlert.errors.company_name" />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field id="companyAddress" label="Company Address" name="companyAddress" type="text" v-model="getUser.company_address" autocomplete="off" :rules="[...getRlDialogRules.stringMax50, ...getRlDialogRules.required]" counter="50" maxlength="50" :error-messages="userUpdateAlert.errors.company_address" />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field id="companyPostcode" label="Company Postcode" name="companyPostcode" type="text" v-model="getUser.company_postcode" autocomplete="off" :rules="[...getRlDialogRules.stringMax20, ...getRlDialogRules.required]" counter="20" maxlength="20" :error-messages="userUpdateAlert.errors.company_postcode" />
                  </v-col>
                  <v-col v-if="hasRole('Ledger User')" cols="12" md="4" >
                    <v-select id="defaultCurrency" label="Default Currency" name="defaultCurrency" :items="getCurrencyList" v-model="getUser.default_cc" item-value="code" item-text="code" autocomplete="off"/>
                  </v-col>
                  <v-col v-if="hasRole('Ledger User')" cols="12" md="4">
                    <v-select id="measureUnit" label="Default Unit of Measure" name="measureUnit" :items="getUnitOfMeasureList" v-model="getUser.default_uom" item-value="code" item-text="code" autocomplete="off"/>
                  </v-col> 
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-dialog v-model="changePasswordDialog" persistent max-width="600px">
              <template v-slot:activator="{on}">
                <v-btn color="primary" v-on="on">Change Password</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Change Password</span>
                </v-card-title>
                <v-card-text>
                  <v-form ref="changePasswordForm">
                    <v-container>
                      <v-row>
                        <v-col cols="12">	
                          <v-alert :value="changePasswordDialogAlert.show" dense outlined :type="changePasswordDialogAlert.type" :icon="changePasswordDialogAlert.icon">{{ changePasswordDialogAlert.message }}</v-alert>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field id="password" label="Current Password" name="password" type="password" v-model="password.password" autocomplete="current-password" :rules="passwordRules" maxlength="30" :error-messages="changePasswordDialogAlert.errors.password" />
                        </v-col>
                        <v-col cols="12">
                          <v-text-field id="password_new" label="New Password" name="password_new" type="password" v-model="password.password_new" autocomplete="new-password" :rules="passwordNewRules" maxlength="30" :error-messages="changePasswordDialogAlert.errors.password_new" />
                        </v-col>
                        <v-col cols="12">
                          <v-text-field id="password_new_conf" label="New Password Confirmation" name="password_new_conf" type="password" v-model="password.password_new_confirmation" :rules="passwordNewConfRules" maxlength="30" />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary darken-1" text @click.prevent="closeChangePasswordDialog()">Close</v-btn>
                  <v-btn color="primary" @click.prevent="changePassword()">Change Password</v-btn>
                    <v-overlay :value="dialogLoading1">
                      <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-spacer />
            <v-btn color="primary" class="mr-0" @click.prevent="updateUser()">Update Profile</v-btn>
            <v-overlay :value="dialogLoading">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
          </v-card-actions>
        </v-card>
      	</v-col>
			</v-row>

      <v-row v-if="hasRole('API User')" justify="center">
        <v-col cols="12">
          <v-card>
            <v-card-title>
              <span class="headline">API Tokens</span>            
              <v-spacer />
              <v-dialog v-model="addTokenDialog" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" v-on="on">Add Token</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Add Token</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="addTokenForm">
                      <v-container>
                        <v-row>
                          <v-col cols="12">	
                            <v-alert :value="addTokenDialogAlert.show" dense outlined :type="addTokenDialogAlert.type" :icon="addTokenDialogAlert.icon">{{ addTokenDialogAlert.message }}</v-alert>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field id="token_name" label="Token Name" name="token_name" type="text" v-model="tokenName" :rules="[...getRlDialogRules.stringMax20, ...getRlDialogRules.required]" counter="50" maxlength="50" />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary darken-1" text @click.prevent="closeAddTokenDialog()">Close</v-btn>
                    <v-btn color="primary" @click.prevent="addToken()">Add Token</v-btn>
                      <v-overlay :value="dialogLoading2">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                      </v-overlay>
                  </v-card-actions>

                  <v-dialog v-model="showTokenDialog" persistent max-width="450">               
                    <v-card>
                      <v-card-title class="headline">API Token</v-card-title>
                      <v-card-text>
                          <div>Please copy the token. You will not be able to see it again!</div>
                          <v-text-field id="tokenField" :value="token" single-line outlined> 
                            <template v-slot:append-outer>
                              <v-icon @click="copyToken">content_copy</v-icon>
                            </template>
                          </v-text-field>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" text @click.prevent="closeShowTokenDialog()">Close</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-card>
              </v-dialog>
            </v-card-title>
            <v-card-text>
              <v-alert :value="revokeTokenAlert.show" dense outlined :type="revokeTokenAlert.type" :icon="revokeTokenAlert.icon" dismissible>{{ revokeTokenAlert.message }}</v-alert>
              <v-data-table :headers="tokensDataTableHeaders" :items="getUser.tokens.data" hide-default-footer class="elevation-1">
                <template v-slot:item.name="{ item }">
                  <span>{{ item.name }}</span>
                </template>
                <template v-slot:item.last_used_at="{ item }">
                  <span>{{ new Date(item.last_used_at).toISOString().substr(0, 19).replace('T', ' ') }}</span>
                </template>
                <template v-slot:item.created_at="{ item }">
                  <span>{{ new Date(item.created_at).toISOString().substr(0, 19).replace('T', ' ') }}</span>
                </template>
                <template v-slot:item.delete="{ item }">
                  <v-icon small @click.prevent="revokeToken(item.id)">delete</v-icon>
                </template>
              </v-data-table>
            </v-card-text>
				  </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import { hasRole } from '@/mixins/hasRole.js'

export default {
  name: 'User',
  mixins: [hasRole],
  mounted(){
    if(this.hasRole('Ledger User')) {
      this.setCurrencyList()
      this.setUnitOfMeasureList()
    }
  },
  data() {
		return {
      dialogLoading: false,
      dialogLoading1: false,
      dialogLoading2: false,
      userUpdateAlert: {show: false, type: null, icon: null, message: null, errors: {}},
      changePasswordDialog: false,
      changePasswordDialogAlert: {show: false, type: null, icon: null, message: null, errors: {}},
      password: {password: null, password_new: null, password_new_confirmation: null},
      passwordRules: [
        value => !!value || 'Current password is required',
      ],
      passwordNewRules: [
        value => !!value || 'New password is required',
        value => (value || '').length >= 8 || 'Minimum 8 characters',
        value => (value || '').length <= 30 || 'Maximum 30 characters'
      ],
      passwordNewConfRules: [
        value => !!value || 'New password confirmation is required',
        value => value === this.password.password_new || 'Password confirmation must match New Password'
      ],
      addTokenDialog: false,
      addTokenDialogAlert: {show: false, type: null, icon: null, message: null, errors: {}},
      tokenName: null,
      showTokenDialog: false,
      token: null,
      revokeTokenAlert: {show: false, type: null, icon: null, message: null},
      tokensDataTableHeaders: [
        { text: 'Name', value: 'name' },
        { text: 'Last Used At', value: 'last_used_at' },
        { text: 'Created At', value: 'created_at' },
        { text: 'Delete', value: 'delete', sortable: false}
      ],
    }
  },
  methods: {
    closeChangePasswordDialog() {
      this.changePasswordDialog = false
      this.$refs.changePasswordForm.reset()
      this.changePasswordDialogAlert = {show: false, type: null, icon: null, message: null, errors: {}}
    },
    async updateUser() {
      if (this.$refs.editUserForm.validate()) {
        try {
          this.dialogLoading = true
          await axios.put('api/v1/users/' + this.getUser.id, this.getUser)
          const response = await axios.get('api/v1/user')
          this.setUser(response.data.data)
          this.dialogLoading = false
        } catch (error) {
          this.dialogLoading = false
          this.userUpdateAlert = {show: true, type: "error", icon: "error", message: error.response.data.message, errors: error.response.data.errors}
        }
      }  
    },
    async changePassword() {
      if (this.$refs.changePasswordForm.validate()) {
        try {
          this.dialogLoading1 = true
          await axios.post('api/v1/user/changePassword', this.password)
          this.changePasswordDialog = false
          this.$refs.changePasswordForm.reset()
          this.changePasswordDialogAlert = {show: false, type: null, icon: null, message: null, errors: {}}
          this.dialogLoading1 = false
        } catch (error) {
          this.dialogLoading1 = false
          this.changePasswordDialogAlert = {show: true, type: "error", icon: "error", message: error.response.data.message, errors: error.response.data.errors}
        }
      }
    },
    async closeShowTokenDialog() {
      try {
        const response = await axios.get('api/v1/user')
        this.setUser(response.data.data)
        this.showTokenDialog = false
        this.addTokenDialog = false
        this.token = null
      } catch (error) {
        //
      }
    },
    closeAddTokenDialog() {
      this.addTokenDialog = false
      this.$refs.addTokenForm.reset()
      this.addTokenDialogAlert = {show: false, type: null, icon: null, message: null}
    },
    async addToken() {
      if (this.$refs.addTokenForm.validate()) {
        try {
          this.dialogLoading2 = true
          const response = await axios.post('api/v1/users/' + this.getUser.id + '/token', {name: this.tokenName})
          this.dialogLoading2 = false
          this.token = response.data.message
          this.showTokenDialog = true
        } catch (error) {
          this.dialogLoading2 = false
          this.addTokenDialogAlert = {show: true, type: "error", icon: "error", message: error.response.data.message, errors: error.response.data.errors}
        }
      }
    },
    copyToken () {
      const token = document.getElementById("tokenField")
      token.select()
      document.execCommand("copy")
    },
    async revokeToken(id) {
      try {  
        this.dialogLoading = true      
        await axios.delete('api/v1/users/' + this.getUser.id + '/token/' + id)
        const response = await axios.get('api/v1/user')
        this.setUser(response.data.data)
        this.dialogLoading = false
      } catch (error) {
        this.dialogLoading = false
        this.revokeTokenAlert = {show: true, type: "error", icon: "error", message: error.response.data.message}
      }
    },
    ...mapActions([
      'setUser',
      'setCurrencyList',
      'setUnitOfMeasureList'
		])
  },
  computed: {
    ...mapGetters([
    'getUser',
    'getCurrencyList',
    'getUnitOfMeasureList',
    'getRlDialogRules'
    ])
  }
}
</script>